module.exports = __webpack_public_path__ + "static/media/Cplus.58393424.png";